import $ from 'jquery';

$.fn.publisher = function (options) {
    $('body').on('submit', '.form form', function (e) {
        e.preventDefault();
        const _form = $(this);
        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            data: $(this).serialize(),

            beforeSend: function () {
                _form.find('.btn').attr('disabled', true);
            },
            success: function (success) {
                _form.find('.form-control').val('');
                _form.find('.media--uploads-list').empty();

                $.alert({
                    title: 'شكرا لك.',
                    theme: 'material',
                    closeIcon: true, // explicitly show the close icon
                    draggable: false,
                    content: 'تم إرسال رسالتك بنجاح. سيقوم فريق الموقع بمتابعة رسالتك والرد عليها في حال توجب ذلك.',
                    buttons:{
                        close:{
                            text: 'إغلاق'
                        }
                    }
                });
            },
            complete: function () {
                _form.find('.btn').removeAttr('disabled');
            },
            error(xhr){
                $.alert({
                    title: 'خطأ',
                    theme: 'material',
                    closeIcon: true, // explicitly show the close icon
                    draggable: false,
                    content: 'يرجى إصلاح الأخطاء في النموذج',
                    buttons:{
                        close:{
                            text: 'إغلاق'
                        }
                    }
                });
                $.each(xhr.responseJSON.errors, function (fieldName, errorsList) {
                    var _message = '';
                    $.each(errorsList, function (index, error) {
                        _message = _message + '<p>' + error + '</p>';
                    });
                    _message = '<div class="help-block">' + _message + '</div>';

                    _form.find('[name="' + fieldName + '"]').parents('.form-group').addClass('has-error')
                        .append(_message);

                });
            }
        });
    });
};


export default class ItemPublisher {
    constructor(selector, options = {}) {
        $(selector).publisher(options)
    }
}


// WEBPACK FOOTER //
// ./src/scripts/ItemPublisher.js